import { useQuery } from '@tanstack/react-query';
import { ErrorResponse, ParamsResponse } from 'interfaces/global.types';
import { toast } from 'react-toastify';
import currencyService from 'services/currency';

export const useCurrencyQuery: any = (params?: ParamsResponse) => {
  const queryKeys = params
    ? ['curreny_getAll', params.page, params.limit, params.search]
    : ['curreny_getAll'];
  return useQuery({
    queryKey: queryKeys,
    queryFn: () => currencyService.getAll(params),
    onError: (error: ErrorResponse) => toast.error(error?.data?.detail),
  });
};
